import { backendFetch } from '@/common/api';

export interface VerifyInvitationResponse {
  email: string;
}

export async function verifyInvitation(
  token: string
): Promise<VerifyInvitationResponse> {
  return backendFetch<VerifyInvitationResponse>(
    `/portal/verify_invitation?token=${token}`,
    {
      credentials: 'include',
    }
  );
}

export async function verifySession(): Promise<VerifyInvitationResponse> {
  return backendFetch<VerifyInvitationResponse>(
    `/portal/verify_invitation_session`,
    {
      credentials: 'include',
    }
  );
}
